import { Injectable } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { ConfigurationRoute } from './../../../providers/semantria-api/configuration-route.service';

@EnableClassTelemetry()
@Injectable()
export class ConfigurationRouteListService {
  private listEmitter$ = new BehaviorSubject<ConfigurationRoute[]>([]);
  private beforeListEntrySelectedEmitter$ = new Subject<ConfigurationRoute>();
  private afterListEntrySelectedEmitter$ = new Subject<ConfigurationRoute>();
  private listEntryUpdatedEmitter$ = new Subject<ConfigurationRoute>();
  private listEntryDeletedEmitter$ = new Subject<ConfigurationRoute>();

  onRoutesLoaded = this.listEmitter$.asObservable();
  onBeforeRouteSelected = this.beforeListEntrySelectedEmitter$.asObservable();
  onAfterRouteSelected = this.afterListEntrySelectedEmitter$.asObservable();
  onRouteUpdated = this.listEntryUpdatedEmitter$.asObservable();
  onRouteDeleted = this.listEntryDeletedEmitter$.asObservable();

  constructor() {}

  routesLoaded(routes: ConfigurationRoute[]) {
    this.listEmitter$.next(routes);
  }

  beforeRouteSelected(route: ConfigurationRoute) {
    this.beforeListEntrySelectedEmitter$.next(route);
  }

  afterRouteSelected(route: ConfigurationRoute) {
    this.afterListEntrySelectedEmitter$.next(route);
  }

  routeUpdated(route: ConfigurationRoute) {
    const routeList = this.listEmitter$.value;
    const idx = routeList.findIndex((cr) => cr.route_id === route.route_id);
    routeList.splice(idx, 1, route);
    routeList.sort((cr1, cr2) => cr1.name.localeCompare(cr2.name));
    this.listEmitter$.next(routeList);
    this.listEntryUpdatedEmitter$.next(route);
  }

  routeDeleted(route: ConfigurationRoute) {
    this.listEmitter$.next(this.listEmitter$.value.filter((cr) => cr.route_id !== route.route_id));
    this.listEntryDeletedEmitter$.next(route);
  }
}
